module.exports = __webpack_public_path__ + "img/logo-url-builder.ced842bc.jpg";